import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import Image from 'next/image';

export default function Footer() {
  const practiceAreas = [
    { id: 'footer_corporate', name: 'Corporate Law', href: '/services#corporate' },
    { id: 'footer_ip', name: 'Intellectual Property', href: '/services#ip' },
    { id: 'footer_tax', name: 'Tax Law', href: '/services#tax' },
    { id: 'footer_formation', name: 'Company Formation', href: '/services#formation' },
  ];

  const countries = [
    { id: 'footer_germany', name: 'Germany', href: '/services#germany' },
    { id: 'footer_uae', name: 'UAE', href: '/services#uae' },
    { id: 'footer_usa', name: 'USA', href: '/services#usa' },
    { id: 'footer_switzerland', name: 'Switzerland', href: '/services#switzerland' },
  ];

  const company = [
    { id: 'footer_about', name: 'About Us', href: '/homepage#about' },
    { id: 'footer_team', name: 'Our Team', href: '/team' },
    { id: 'footer_contact', name: 'Contact', href: '/contact' },
  ];

  return (
    <footer className="bg-muted border-t border-border">
      <div className="max-w-8xl mx-auto px-6 md:px-12 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-4">
            <Link href="/homepage" className="flex items-center gap-3 mb-6">
              <Image
                src="/assets/images/cyfire-intl-dark-transparent-1775806022629.png"
                alt="Cyfire International Logo"
                width={180}
                height={60}
                className="h-12 w-auto object-contain hover:opacity-80 transition-opacity"
              />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed mb-6 max-w-xs">
              International legal excellence across 12 jurisdictions. Expert counsel for your global business needs.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-primary/30 flex items-center justify-center hover:bg-primary hover:border-primary hover:text-primary-foreground transition-all shadow-md hover:shadow-lg"
                aria-label="LinkedIn"
              >
                <Icon name="GlobeAltIcon" size={18} />
              </a>
              <a
                href="mailto:info@cyfire-international.com"
                className="w-10 h-10 rounded-full border-2 border-primary/30 flex items-center justify-center hover:bg-primary hover:border-primary hover:text-primary-foreground transition-all shadow-md hover:shadow-lg"
                aria-label="Email"
              >
                <Icon name="EnvelopeIcon" size={18} />
              </a>
            </div>
          </div>

          {/* Practice Areas */}
          <div className="md:col-span-2">
            <h5 className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-4">
              Practice Areas
            </h5>
            <ul className="space-y-3">
              {practiceAreas?.map((item) => (
                <li key={item?.id}>
                  <Link
                    href={item?.href}
                    className="text-sm text-foreground hover:text-primary transition-colors"
                  >
                    {item?.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Countries */}
          <div className="md:col-span-2">
            <h5 className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-4">
              Countries
            </h5>
            <ul className="space-y-3">
              {countries?.map((item) => (
                <li key={item?.id}>
                  <Link
                    href={item?.href}
                    className="text-sm text-foreground hover:text-primary transition-colors"
                  >
                    {item?.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-2">
            <h5 className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-4">
              Company
            </h5>
            <ul className="space-y-3">
              {company?.map((item) => (
                <li key={item?.id}>
                  <Link
                    href={item?.href}
                    className="text-sm text-foreground hover:text-primary transition-colors"
                  >
                    {item?.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t-2 border-primary/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © 2026 CYFIRE International. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-muted-foreground">
            <Link href="/impressum" className="hover:text-primary transition-colors">
              Impressum
            </Link>
            <Link href="/datenschutz" className="hover:text-primary transition-colors">
              Datenschutzerklärung
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}